import React from 'react';
import { Hero } from './components/Hero';
import { PriceComparison } from './components/PriceComparison';
import { AlbumCarousel } from './components/AlbumCarousel';
import { EmotionalHook } from './components/EmotionalHook';
import { ProblemAgitation } from './components/ProblemAgitation';
import { Solution } from './components/Solution';
import { PricingCards } from './components/PricingCards';
import { TargetAudience } from './components/TargetAudience';
import { TeamsGrid } from './components/TeamsGrid';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans selection:bg-wc-yellow selection:text-wc-dark" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <PriceComparison data-id="element-4" />
        <AlbumCarousel data-id="element-5" />
        <EmotionalHook data-id="element-6" />
        <ProblemAgitation data-id="element-7" />
        <Solution data-id="element-8" />
        <PricingCards data-id="element-9" />
        <TargetAudience data-id="element-10" />
        <TeamsGrid data-id="element-11" />
        <HowItWorks data-id="element-12" />
        <Testimonials data-id="element-13" />
        <Guarantee data-id="element-14" />
        <Urgency data-id="element-15" />
        <ComparisonTable data-id="element-16" />
        <FinalCTA data-id="element-17" />
        <FAQ data-id="element-18" />
      </main>
      <Footer data-id="element-19" />
    </div>;
}